import React, {memo, useState} from 'react';
import SectionNavigation from "../../Framework/Components/Navigation/SectionNavigation";
import {useLayout} from "../../Framework/Providers/LayoutProvider";
import {iNavigationEntry} from "../../Framework/Components/Navigation/SectionNavigationEntry";

const SendsMenuEntries: Array<iNavigationEntry> = [
    { title: 'Profiles', path: '/'},
    { title: 'Users', path: '/sends-admin/users'},
    { title: 'History', path: '/sends-admin/history'},
    { title: 'Address Importer', path: '/address-importer'},
]

const SendsAdminNavigation = memo((props: any) => {
    const [ sendsMenuData, setSendsMenuData] = useState<Array<iNavigationEntry>>(SendsMenuEntries);

    const { isLarge } = useLayout();

    return (
        <div className={'content-menu'}>
            <SectionNavigation
                title={!isLarge ? props.title : 'Sends Admin'}
                entries={sendsMenuData}
                rounded={true}
                addonContent={props.addonContent}
            />
        </div>
    );
});

export default SendsAdminNavigation;
